import { EmptystateSearchNoResultsColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";

const TemplateDeploymentOutputsEmpty = () => {
  return (
    <EmptyState
      icon={EmptystateSearchNoResultsColored}
      title="No outputs"
      caption="This deployment has no outputs."
      announce
    />
  );
};

export default TemplateDeploymentOutputsEmpty;
